<template>
  <div class="study-visa">
    <h1>学习签证</h1>
    <p class="subtitle">学习签证</p>
    
    <div class="content">
      <div class="text-content">
        <p>加拿大政府规定，任何外国人在加拿大境内指定的学习机构DLI（Designated Learning Institutions）学习6个月以上的学习，必须在入境前申请并获得study permit (除非是豁免情况 section R188，R214或R215）。</p>
        
        <p>如果在加拿大境内持visitor visa则不能在加拿大境内获得Study Permit，必须出境申请并获批后再回来 (除非是section R215例外情况)</p>
        
        <h2>哪些人豁免学签Exceptions</h2>
        <ul>
          <li>6个月及以下的短期学习6 months or less short-term study</li>
          <li>兴趣或自我提升课程courses of general interest or self-improvement</li>
          <li>远程学习distance learning</li>
          <li>旁听课程（学听但不获得学分）audited courses</li>
          <li>难民或难民申请人refugees or refugee claimants</li>
          <li>18或19岁以下在幼儿园、学前班、小学或中学，与父母一起已经在加拿大，其父母持有工签或学签（当年龄达到成人年龄18或19岁时必须申请学签）</li>
          <li>外国代表的家庭成员和员工Family or staff of foreign representatives</li>
          <li>外国武装部队成员Member of foreign armed forces</li>
          <li>注册的印第安人Registered Indian</li>
          <li>参加法语语言和文化课程的临时居民和寻求庇护者Temporary residents and asylum seekers taking French language and culture courses</li>
          <li>参加安置和融入课程的临时居民Temporary residents taking settlement and integration courses</li>
        </ul>

        <p>学签有效期通常为1-4年，根据所读学校和专业决定。学签到期自动延长90天，在此期间内学生可以继续在加拿大，但是不能继续参加学习和学术课程，90天到期前必须离境，除非申请了PGWP可以继续留在加拿大和工作。如果没有资格申请PGWP或者没有申请，否则想留在加拿大则必须转换身份成visitor或者worker (如果有job offer)，要么申请visitor record extension。</p>

        <h2>学签什么时间无效</h2>
        <p>在以下最先到时失效:</p>
        <ul>
          <li>完成学业后的90天</li>
          <li>取得令生效之日</li>
          <li>学签到期日</li>
        </ul>
      </div>
      
      <div class="image-content">
        <img src="../../assets/zvvv.jpg" alt="Study Visa">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudyVisaView'
}
</script>

<style scoped>
.study-visa {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
}

.content {
  display: flex;
  gap: 40px;
}

.text-content {
  flex: 1;
}

.image-content {
  flex: 1;
}

img {
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
}

h2 {
  font-size: 24px;
  margin: 30px 0 20px;
}

ul {
  list-style-type: disc;
  padding-left: 20px;
  margin-bottom: 20px;
}

li {
  margin-bottom: 10px;
  line-height: 1.6;
}

p {
  margin-bottom: 15px;
  line-height: 1.6;
}
</style>